<span>{{ (objectTitle$ | async) || '' }}</span>
